// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"5d94809f","408":"b9f624c3","453":"7a732791"}[chunkId] + ".chunk.js";
};